import React from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { Box, Spinner, Text, HStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const MotionBox = motion(Box);

const WalletStatus = () => {
  const { connecting, connected, disconnecting } = useWallet();
  const location = useLocation();
  
  // Don't show the wallet status on the auction page to avoid duplicate buttons
  if (location.pathname === '/auction' || (!connecting && !disconnecting && !connected)) {
    return null;
  }

  return (
    <MotionBox
      position="fixed"
      bottom="4"
      right="4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      zIndex="tooltip"
    >
      <HStack
        spacing={3}
        bg="rgba(13, 16, 25, 0.9)"
        borderRadius="full"
        px={4}
        py={2}
        borderWidth="1px"
        borderColor={connected ? "green.500" : "yellow.500"}
        boxShadow="lg"
      >
        <Spinner 
          size="sm" 
          color={connected ? "green.500" : "yellow.500"}
          display={connecting || disconnecting ? "block" : "none"}
        />
        <Text color="white" fontSize="sm">
          {connecting && "Connecting wallet..."}
          {disconnecting && "Disconnecting wallet..."}
          {connected && !connecting && !disconnecting && "Wallet connected"}
        </Text>
      </HStack>
    </MotionBox>
  );
};

export default WalletStatus;
